/*
================================================================ 
        Copyright (c) 2018-2020 Digitize Things Inc.           
                    All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useState, useRef } from "react";
import Grid from "@mui/material/Grid";
//componenets
import Button from "../../../component/button";
import Input from "../../../component/inputpm";
import { withTranslation } from "react-i18next";
import Loader from "../../../component/loader";
import actionTypes from "../../../store/actions";
import { connect } from "react-redux";
import BusApiCall from "../../../helper/axios.js";
import constants from "../../../helper/constants";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import Card from "@mui/material/Card";
import { EditIconNew } from "../../../component/icons/icons.js";
import { Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import { makeStyles } from '@mui/styles';

const AddPartnerUser = (props) => {
  const t = props.t;
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState({
    firstName: "",
    lastName: "",
    loginId: "",
    emailAddress: "",
    password: "",
    repeatPassword: "",
    solutionProviderId: props.tenantId,
    authTenantId: props.authTenantId,
  });
  const [isPasswordRequired, setIsPasswordRequired] = useState("true");
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const [error, setError] = useState({});
  // const styles = makeStyles({
  //   resizablePaper: {
  //     resize: 'both',
  //     overflow: 'auto',
  //     minWidth: 640,
  //     minHeight: 200,
  //     maxWidth: '90vw',
  //     maxHeight: '90vh',
  //     width: '60vw',
  //   },
  // });
  // const jssClasses = styles();

  useEffect(() => {
    props.setErrorMessage();
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/passthru/GET_PARTY_CONFIGS/endpoint`,
      {},
    ).then((res) => {
      let isPasswordRequired = res.data["party.login.password.required"]
        ? res.data["party.login.password.required"]
        : "true";
      setIsPasswordRequired(isPasswordRequired);
    });
    props.getUserList();
  }, []);

  const validateDetails = () => {
    const error = {};
    if (!details.firstName) {
      error.firstName = t("FIRST_NAME_IS_REQUIRED");
    }
    if (!details.lastName) {
      error.lastName = t("LAST_NAME_IS_REQUIRED");
    }
    if (!details.loginId) {
      error.loginId = t("USERNAME_IS_REQUIRED");
    }
    if (!details.emailAddress) {
      error.emailAddress = t("EMAIL_IS_REQUIRED");
    } else if (!/\S+@\S+\.\S+/.test(details.emailAddress)) {
      error.emailAddress = t("EMAIL_IS_INVALID");
    }
    if (isPasswordRequired === "true") {
      if (!details.password) {
        error.password = t("PASSWORD_IS_REQUIRED");
      }
      if (!details.repeatPassword) {
        error.repeatPassword = t("CONFIRM_PASSWORD_IS_REQUIRED");
      }
      if (details.password !== details.repeatPassword) {
        error.repeatPassword = t("PASSWORD_MISMATCH_ERROR");
      }
    }
    setError(error);
    if (Object.keys(error).length === 0) {
      return true;
    }
  };

  const addNewUser = () => {
    if (validateDetails()) {
      let data = JSON.parse(JSON.stringify(details));
      if (isPasswordRequired !== "true") {
        let updatedDetails = { ...details };
        delete updatedDetails.password;
        delete updatedDetails.repeatPassword;
        updatedDetails.loginId = updatedDetails.loginId?.toLowerCase() || "";
        props.submitData(updatedDetails);
      } else {
        data.loginId = data.loginId?.toLowerCase() || "";
        props.submitData(data);
      }
      // setDetails({
      //   firstName: "",
      //   lastName: "",
      //   loginId: "",
      //   emailAddress: "",
      //   password: "",
      //   repeatPassword: "",
      //   solutionProviderId: props.tenantId,
      //   authTenantId: props.authTenantId
      // })
    }
  };

  const handlePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const handleRepeatPasswordVisibility = () => {
    setShowRepeatPassword((prevShowRepeatPassword) => !prevShowRepeatPassword);
  };

  const [showEditUser, toggleEditUser] = useState(false);
  const [editUserData, setEditUserdata] = useState({});
  const editUser = (user) => {
    // setEditUserdata(user);
    setDetails(user);
    toggleEditUser(true);
    // setLoading(false);
    props.showLoader(false);
  };
  const closeEditDialog = () => {
    clearForm();
    toggleEditUser(false);
  };
  const updateUser = () => {
    const error = {};
    if (!details.firstName) {
      error.firstName = t("FIRST_NAME_IS_REQUIRED");
    }
    if (!details.lastName) {
      error.lastName = t("LAST_NAME_IS_REQUIRED");
    }
    if (!details.emailAddress) {
      error.emailAddress = t("EMAIL_IS_REQUIRED");
    } else if (!/\S+@\S+\.\S+/.test(details.emailAddress)) {
      error.emailAddress = t("EMAIL_IS_INVALID");
    }
    setError(error);
    if (Object.keys(error).length === 0) {
      // setLoading(true);
      props.showLoader(true);
      var payload = {
        firstName: details.firstName,
        lastName: details.lastName,
        emailAddress: details.emailAddress,
      };
      BusApiCall(
        "PATCH",
        `${constants.busV4Url}/solution-provider/${props.tenantId}/employee/${details.employeeId}`,
        payload,
      )
        .then((res) => {
          props.setErrorMessage(t("USER_UPDATED_SUCCESSFULLY"), true);
          props.getUserList();
          closeEditDialog();
          // setLoading(false);
          props.showLoader(false);
        })
        .catch((err) => {
          // Error handling
          if (err.response && err.response.data && err.response.data.message) {
            props.setErrorMessage(err.response.data.message, false);
          } else {
            props.setErrorMessage(t("SOMETHING_WENT_WRONG"), false);
          }
          closeEditDialog();
          // setLoading(false);
          props.showLoader(false);
        });
    } else {
      return true;
    }
  };
  const clearForm = () => {
    setDetails({
      firstName: "",
      lastName: "",
      loginId: "",
      emailAddress: "",
      password: "",
      repeatPassword: "",
      solutionProviderId: props.tenantId,
      authTenantId: props.authTenantId,
    });
    setError({});
    setShowPassword(false);
    setShowRepeatPassword(false);
  };
  return (
    <>
      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h3 className={"no-margin"}>{t("USER_DETAILS")}</h3>
        <Button
          variant="contained"
          color="primary"
          onClick={props.handleToggleDialog}
        >
          {t("ADD_NEW_USER")}
        </Button>
      </div> */}
      <div style={{ textAlign: "right", marginBottom: "16px" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={props.handleToggleDialog}
        >
          {t("ADD_NEW_USER")}
        </Button>
      </div>
      <Card variant="outlined" style={{ borderRadius: "8px" }}>
        <TableContainer>
          <Table className={"newGlobalTable"} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">
                  <b>{t("FIRST_NAME")}</b>
                </TableCell>
                <TableCell align="left">
                  <b>{t("LAST_NAME")}</b>
                </TableCell>
                <TableCell align="left">
                  <b>{t("EMAIL")}</b>
                </TableCell>
                <TableCell align="left">
                  <b>{t("USERNAME")}</b>
                </TableCell>
                <TableCell align="left">
                  <b>{t("ACTION")}</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.userList && props.userList.length > 0 ? (
                props.userList.map((user, index) => (
                  <React.Fragment key={index}>
                    <TableRow align="center">
                      <TableCell align="left">
                        <span>{user.firstName}</span>
                      </TableCell>
                      <TableCell align="left">
                        <span>{user.lastName}</span>
                      </TableCell>
                      <TableCell align="left">
                        <span>{user.emailAddress}</span>
                      </TableCell>
                      <TableCell align="left">
                        <span>{user.userLoginId}</span>
                      </TableCell>
                      <TableCell align="left">
                        <span>
                          <Button
                            onClick={() => editUser(user)}
                            className="buttonSecondary"
                          >
                            <span style={{ marginRight: "8px" }}>
                              <EditIconNew />
                            </span>
                            {t("EDIT")}
                          </Button>
                          {/* <svg onClick={() => editUser(user)} class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="Edit"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path></svg> */}
                        </span>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))
              ) : (
                <TableRow align="center">
                  <TableCell colSpan={5} align="center">
                    {t("NO_USERS_AVAILABLE")}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
      {/* show add new user dialog */}
      <Dialog
        PaperComponent={DraggableDialogPaper}
        open={props.showAddNewUser || showEditUser}
        // onClose={props.handleToggleDialog}
        fullWidth={true}
        maxWidth={"sm"}
        style={{ maxHeight: "90vh" }}
        // PaperProps={{
        //   className: jssClasses.resizablePaper
        // }}
        disableScrollLock={true}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "95%" }}>
              {(showEditUser ? t("UPDATE_USER") : t("ADD_NEW_USER")) +
                ": " +
                props.tenantData.title}
            </span>
            <Tooltip title={t("CLOSE")}>
              <IconButton
                onTouchStart={() => {
                  if (showEditUser) {
                    closeEditDialog();
                  } else {
                    clearForm();
                    props.handleToggleDialog();
                  }
                }}
                onClick={() => {
                  if (showEditUser) {
                    closeEditDialog();
                  } else {
                    clearForm();
                    props.handleToggleDialog();
                  }
                }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <Input
                error={!!error.firstName}
                helperText={error.firstName}
                name={"firstName"}
                size={"small"}
                variant={"outlined"}
                value={details.firstName}
                placeholder={t("FIRST_NAME") + "*"}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    [e.target.name]: e.target.value,
                  });
                  setError({ ...error, [e.target.name]: "" });
                }}
              />
            </Grid>
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <Input
                error={!!error.lastName}
                helperText={error.lastName}
                name={"lastName"}
                size={"small"}
                variant={"outlined"}
                value={details.lastName}
                placeholder={t("LAST_NAME") + "*"}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    [e.target.name]: e.target.value,
                  });
                  setError({ ...error, [e.target.name]: "" });
                }}
              />
            </Grid>
            {showEditUser ? (
              ""
            ) : (
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <Input
                  error={!!error.loginId}
                  helperText={error.loginId}
                  name={"loginId"}
                  size={"small"}
                  variant={"outlined"}
                  value={details.loginId}
                  placeholder={t("USERNAME") + "*"}
                  onChange={(e) => {
                    setDetails({
                      ...details,
                      [e.target.name]: e.target.value?.toLowerCase(),
                    });
                    setError({ ...error, [e.target.name]: "" });
                  }}
                />
              </Grid>
            )}
            <Grid
              item
              size={{
                xs: 6,
              }}
            >
              <Input
                error={!!error.emailAddress}
                helperText={error.emailAddress}
                name={"emailAddress"}
                size={"small"}
                variant={"outlined"}
                value={details.emailAddress}
                placeholder={t("CONTACT_EMAIL") + "*"}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    [e.target.name]: e.target.value,
                  });
                  setError({ ...error, [e.target.name]: "" });
                }}
              />
            </Grid>
            {isPasswordRequired === "true" && !showEditUser && (
              <>
                <Grid
                  item
                  size={{
                    xs: 6,
                  }}
                >
                  {!navigator.userAgent.includes("Edg") ? ( //check added incase of MS Edge where it would add a password eye icon by default
                    <Input
                      error={!!error.password}
                      helperText={error.password}
                      name={"password"}
                      size={"small"}
                      variant={"outlined"}
                      value={details.password}
                      placeholder={t("PASSWORD") + "*"}
                      onChange={(e) => {
                        setDetails({
                          ...details,
                          [e.target.name]: e.target.value,
                        });
                        setError({ ...error, [e.target.name]: "" });
                      }}
                      type={showPassword ? "text" : "password"}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handlePasswordVisibility}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  ) : (
                    <Input
                      error={!!error.password}
                      helperText={error.password}
                      name={"password"}
                      size={"small"}
                      variant={"outlined"}
                      value={details.password}
                      placeholder={t("PASSWORD") + "*"}
                      onChange={(e) => {
                        setDetails({
                          ...details,
                          [e.target.name]: e.target.value,
                        });
                        setError({ ...error, [e.target.name]: "" });
                      }}
                      type={showPassword ? "text" : "password"}
                    />
                  )}
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 6,
                  }}
                >
                  {!navigator.userAgent.includes("Edg") ? ( //check added incase of MS Edge where it would add a password eye icon by default
                    <Input
                      error={!!error.repeatPassword}
                      helperText={error.repeatPassword}
                      name={"repeatPassword"}
                      size={"small"}
                      variant={"outlined"}
                      value={details.repeatPassword}
                      placeholder={t("REPEAT_PASSWORD") + "*"}
                      onChange={(e) => {
                        setDetails({
                          ...details,
                          [e.target.name]: e.target.value,
                        });
                        setError({ ...error, [e.target.name]: "" });
                      }}
                      type={showRepeatPassword ? "text" : "password"}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleRepeatPasswordVisibility}
                              edge="end"
                            >
                              {showRepeatPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  ) : (
                    <Input
                      error={!!error.repeatPassword}
                      helperText={error.repeatPassword}
                      name={"repeatPassword"}
                      size={"small"}
                      variant={"outlined"}
                      value={details.repeatPassword}
                      placeholder={t("REPEAT_PASSWORD") + "*"}
                      onChange={(e) => {
                        setDetails({
                          ...details,
                          [e.target.name]: e.target.value,
                        });
                        setError({ ...error, [e.target.name]: "" });
                      }}
                      type={showRepeatPassword ? "text" : "password"}
                    />
                  )}
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          {/* <Button onClick={showEditUser ? closeEditDialog : props.handleToggleDialog} color="primary" className="buttonSecondary">
            {t("CANCEL")}
          </Button> */}
          {showEditUser ? (
            <Button
              onClick={() => updateUser()}
              color="primary"
              variant="contained"
            >
              {t("UPDATE")}
            </Button>
          ) : (
            <Button
              onClick={(event) => addNewUser()}
              color="primary"
              variant="contained"
            >
              {props.showAddNewUser ? t("ADD_NEW_USER") : t("SAVE")}
            </Button>
          )}
          {/* <Loader loading={loading} /> */}
        </DialogActions>
      </Dialog>
    </>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

const mapStateToProps = (state) => {
  return {
    tenantId: state.auth.tenantId,
    countriesList: state.global.countriesList,
    tenantData: state.auth.tenantData,
    authTenantId: state.auth.tenantInfo.tenantId,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(AddPartnerUser));
